<template>
<router-view />
</template>

<script>
export default {
  name: 'Sensitivity',
  routeInfo: {
    label: '敏感性分析',
    icon: 'fa fa-users'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/03Sensitivity/index.vue